// @flow strict
import * as React from 'react';
import { Search } from '@ansarada/icons';
// import TypeWritter from 'typewriter-effect';
import Typewriter from 'typewriter-effect/dist/core';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';

import type { Product } from './types';

export interface HighlightProps {
  products: Product[];
  current: number;
}

export function Highlight(props: HighlightProps) {
  React.useEffect(() => {
    const target = document.querySelector('#typewriter');
    const typewritter = new Typewriter(target, {
      cursor: ``,
    });
    const { title } = props.products[props.current];
    typewritter
      .typeString(title)
      .pauseFor(title.length * (title.length < 9 ? 1000 : 300))
      .deleteAll()
      .start();
  }, [props.current]);

  return (
    <div className={styles.homeHeroHighlight}>
      <p className={styles.homeHeroHighlightText}>
        <div id="typewriter" />
      </p>
      <Search color="white" size="XLarge" />
    </div>
  );
}
